<app-menu-common url="home"></app-menu-common>

<div class="si-page">
  <div class="flexrow si-header">
    <h2>Informations du serveur</h2>
    <span class="si-hint">{{ serverUrl }}/info</span>
    <span class="spacer"></span>
    <button mat-stroked-button type="button" id="serverinforefresh" [disabled]="loading()" (click)="load()"><mat-icon>refresh</mat-icon>&nbsp;Actualiser</button>
  </div>

  @if (error(); as err) {
    <div class="si-error" role="alert"><mat-icon>error_outline</mat-icon>{{ err }}</div>
  }

  @if (info(); as i) {
    <section class="si-versions">
      <div class="si-tile si-tile-main">
        <span class="si-tile-label">Serveur</span>
        <span class="si-tile-value">v{{ i.version ?? '?' }}</span>
        <span class="si-tile-sub">Cargo.toml racine</span>
      </div>
      <div class="si-tile">
        <span class="si-tile-label">apiserver</span>
        <span class="si-tile-value">v{{ i.apiserver_version ?? '?' }}</span>
        <span class="si-tile-sub">crate apiserver</span>
      </div>
      <div class="si-tile">
        <span class="si-tile-label">Front</span>
        <span class="si-tile-value">v{{ frontVersion }}</span>
        <span class="si-tile-sub">package.json</span>
      </div>
      <div class="si-tile">
        <span class="si-tile-label">fselib</span>
        <span class="si-tile-value">v{{ fselibVersion }}</span>
        <span class="si-tile-sub">mercalink-fselib</span>
      </div>
      <div class="si-tile">
        <span class="si-tile-label">Environnement</span>
        <span class="si-tile-value si-tile-text">{{ i.environment }}</span>
        <span class="si-tile-sub">{{ serverUrl }}</span>
      </div>
    </section>

    @if (current(); as cur) {
      <section class="si-card si-current">
        <h3>
          <mat-icon>rocket_launch</mat-icon>En production : {{ cur.version }}
          <span class="si-chip">{{ cur.level }}</span>
          <span class="si-date">{{ cur.date }}</span>
        </h3>
        <dl class="si-fields">
          @for (f of cur.fields; track $index) {
            <dt>{{ f.label }}</dt>
            <dd [innerHTML]="f.html"></dd>
          }
        </dl>
        @for (n of cur.notes; track $index) {
          <p class="si-note" [innerHTML]="n"></p>
        }
      </section>
    } @else {
      <section class="si-card"><p class="si-hint">Fichier release vide ou illisible : aucune mise en production enregistrée.</p></section>
    }

    <div class="si-columns">
      <section class="si-card si-journal">
        <h3><mat-icon>history</mat-icon>{{ journal().title || 'Journal des mises en production' }}</h3>
        @for (p of journal().intro; track $index) {
          <p class="si-hint" [innerHTML]="p"></p>
        }
        @for (e of history(); track $index; let first = $first) {
          <article class="si-release" [class.si-release-current]="first">
            <header class="flexrow">
              <span class="si-release-version">{{ e.version }}</span>
              <span class="si-chip">{{ e.level }}</span>
              <span class="spacer"></span>
              <span class="si-date">{{ e.date }}</span>
            </header>
            <dl class="si-fields">
              @for (f of e.fields; track $index) {
                <dt>{{ f.label }}</dt>
                <dd [innerHTML]="f.html"></dd>
              }
            </dl>
            @for (s of e.sections; track $index) {
              <div class="si-subtitle">{{ s.title }}</div>
              <ul>
                @for (item of s.items; track $index) {
                  <li [innerHTML]="item"></li>
                }
              </ul>
            }
          </article>
        }
      </section>

      <section class="si-card si-config">
        <h3><mat-icon>tune</mat-icon>Configuration</h3>
        <p class="si-hint">Les valeurs sensibles (mot de passe, jeton) sont masquées par le serveur.</p>
        @for (s of configSections(); track s.name) {
          <table class="si-table">
            <caption>{{ s.name }}</caption>
            <tbody>
              @for (r of s.rows; track r.key) {
                <tr>
                  <th scope="row">{{ r.key }}</th>
                  <td [class.si-masked]="r.masked">
                    @if (r.masked) {
                      <mat-icon inline>lock</mat-icon>&nbsp;masqué
                    } @else {
                      {{ r.value }}
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </section>
    </div>

    <details class="si-card si-raw">
      <summary>Réponse brute de /info</summary>
      <pre>{{ rawJson() }}</pre>
    </details>
  } @else if (loading()) {
    <p class="si-hint">Chargement…</p>
  }
</div>
